
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "16px",
    "height": "14px",
    "viewBox": "0 0 16 14",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "坐标"
        }
      ]
    },
    {
      "tag": "defs",
      "children": [
        {
          "tag": "filter",
          "attrsMap": {
            "id": "filter-1"
          },
          "children": [
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "in": "SourceGraphic",
                "type": "matrix",
                "values": "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0.850000 0"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "监控页-单车单摄像头",
            "transform": "translate(-1120.000000, -433.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "坐标",
                "transform": "translate(952.000000, 419.000000)",
                "filter": "url(#filter-1)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "transform": "translate(168.000000, 14.000000)"
                  },
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#000000",
                        "fill-rule": "nonzero",
                        "opacity": "0",
                        "x": "0",
                        "y": "0",
                        "width": "16",
                        "height": "14"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M14.8986907,9.23222855 L11.4836941,8.13183263 L11.4836941,9.01620102 L9.50797759,9.01620102 C9.3861402,7.37870924 7.88977873,6.06939296 6.01835956,5.96278524 L6.01835955,3.86778964 L7.02906628,3.86778964 L5.77147094,0.879247865 L4.51387559,3.86778964 L5.52458233,3.86778964 L5.52458233,5.96277124 C3.65359486,6.06940694 2.15728136,7.37870923 2.03544397,9.01618702 L1.10129333,9.01618703 L1.10129333,9.4482421 L2.03544397,9.4482421 C2.15728136,11.0857199 3.65359486,12.3950362 5.52458233,12.5016719 L5.52458233,13.1207381 L6.01837553,13.1207381 L6.01837553,12.5016719 C7.8898107,12.3950642 9.38615617,11.0857339 9.50799356,9.4482421 L11.483694,9.4482421 L11.483694,10.3326105 L14.8986907,9.23222855 Z M7.5862885,9.01618703 L6.01835956,9.01618703 L6.01835956,7.64424921 C6.83244759,7.74021013 7.47661886,8.30385998 7.5862885,9.01618703 Z M5.52458233,7.64427718 L5.52458233,9.01620102 L3.95714905,9.01620102 C4.06678672,8.30390195 4.71087803,7.74026611 5.52458233,7.64427718 Z M3.95714905,9.4482421 L5.52458233,9.4482421 L5.52458233,10.8201659 C4.71091,10.7241211 4.06683469,10.1602613 3.95714905,9.4482421 Z M6.01835955,10.8201659 L6.01835955,9.4482421 L7.5862725,9.4482421 C7.47658687,10.1602893 6.83241563,10.724163 6.01835955,10.8201659 Z",
                        "id": "形状",
                        "fill": "#000000",
                        "fill-rule": "nonzero"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  